import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium truncate" }, "Data Materi", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Tambah", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_9 = { class: "intro-y col-span-12" }
const _hoisted_10 = { class: "intro-y col-span-12 box pt-3 pb-5" }
const _hoisted_11 = { class: "flex flex-row mb-3 items-end px-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  href: "javascript:;",
  class: "rounded-full px-1 ml-3 text-gray-600",
  name: "tooltip-active-inactive"
}
const _hoisted_16 = { class: "w-5 h-5 flex items-center justify-center" }
const _hoisted_17 = ["src", "title"]
const _hoisted_18 = { class: "flex flex-row truncate items-center" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "flex flex-row justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Autocomplete = _resolveComponent("Autocomplete")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_TooltipActiveInactive = _resolveComponent("TooltipActiveInactive")!
  const _component_ChipActiveInactive = _resolveComponent("ChipActiveInactive")!
  const _component_CopyIcon = _resolveComponent("CopyIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_Edit3Icon = _resolveComponent("Edit3Icon")!
  const _component_Trash2Icon = _resolveComponent("Trash2Icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalFormlMateri = _resolveComponent("ModalFormlMateri")!
  const _component_ModalDetailMateri = _resolveComponent("ModalDetailMateri")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button bg-theme-1 hover:bg-primary text-white flex items-center w-auto mr-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewMateri && _ctx.addNewMateri(...args)))
            }, [
              _createVNode(_component_PlusIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getListMateriData && _ctx.getListMateriData(...args))),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_8
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_TextField, {
            value: _ctx.dataMateri.search,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataMateri.search) = $event)),
            label: "Search",
            type: "text",
            placeholder: "Search...",
            class: "w-72 mr-3"
          }, null, 8, ["value"]),
          _createVNode(_component_Autocomplete, {
            value: _ctx.dataMateri.types,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataMateri.types) = $event)),
            label: "Tipe",
            items: _ctx.filterTypes,
            class: "w-52 mr-3"
          }, null, 8, ["value", "items"]),
          _createVNode(_component_Autocomplete, {
            value: _ctx.dataMateri.category,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataMateri.category) = $event)),
            label: "Kategori",
            items: _ctx.categories,
            class: "w-60 mr-3"
          }, null, 8, ["value", "items"]),
          _createVNode(_component_Autocomplete, {
            value: _ctx.dataMateri.topic,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataMateri.topic) = $event)),
            label: "Topik",
            items: _ctx.topics,
            class: "w-60 mr-3"
          }, null, 8, ["value", "items"]),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getListMateriData && _ctx.getListMateriData(...args))),
            class: "button bg-theme-1 hover:bg-primary text-white w-24 h-10"
          }, " View ")
        ]),
        _hoisted_12,
        _createVNode(_component_DataTable, {
          headers: _ctx.tabelHeaders,
          items: _ctx.dataMateriItems,
          loading: _ctx.dataMateri.loading,
          "loading-div-id": "loadingDMadmin",
          "page-size": _ctx.dataMateri.pageSize,
          "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataMateri.pageSize) = $event)),
          page: _ctx.dataMateri.page,
          "onUpdate:page": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataMateri.page) = $event)),
          "total-data": _ctx.dataMateri.totalData,
          "onUpdate:total-data": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataMateri.totalData) = $event))
        }, {
          [`header.title`]: _withCtx(({ header }) => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                innerHTML: header.text
              }, null, 8, _hoisted_14),
              _createElementVNode("a", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_InfoIcon, { class: "w-5 h-5" })
                ])
              ]),
              _createVNode(_component_TooltipActiveInactive)
            ])
          ]),
          [`item.banner`]: _withCtx(({ item }) => [
            _createElementVNode("img", {
              class: "max-w-full",
              src: item.banner,
              alt: "Banner Image",
              title: 'Banner ' + item.title,
              "data-action": "zoom"
            }, null, 8, _hoisted_17)
          ]),
          [`item.title`]: _withCtx(({ item }) => [
            _createVNode(_component_ChipActiveInactive, {
              type: item.isActive ? 'active' : 'inactive',
              text: item.title
            }, null, 8, ["type", "text"])
          ]),
          [`item.content`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block mr-2",
                content: "Copy Link",
                onClick: ($event: any) => (_ctx.gpf.copy(item.content))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CopyIcon, { class: "w-6 h-6 cursor-pointer text-primary" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createElementVNode("a", {
                href: item.content,
                target: "_blank",
                class: "truncate"
              }, _toDisplayString(item.content), 9, _hoisted_19)
            ])
          ]),
          [`item.createdAt`]: _withCtx(({ value }) => [
            _createElementVNode("p", _hoisted_20, [
              _createTextVNode(_toDisplayString(_ctx.$h.formatDate(value, "DD MMM, YYYY")) + " ", 1),
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.$h.formatDate(value, "HH:mm:ss")), 1)
            ])
          ]),
          [`item.action`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block mr-2",
                content: "Detail",
                onClick: ($event: any) => (_ctx.showModalDetailMateri(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FileIcon, { class: "w-6 h-6 cursor-pointer text-primary" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block mr-2",
                content: "Edit",
                onClick: ($event: any) => (_ctx.editMateri(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Edit3Icon, { class: "w-6 h-6 cursor-pointer text-theme-12" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block",
                content: "Hapus",
                onClick: ($event: any) => (_ctx.deleteMateriPopup(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Trash2Icon, { class: "w-6 h-6 cursor-pointer text-theme-6" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["headers", "items", "loading", "page-size", "page", "total-data"])
      ])
    ]),
    _createVNode(_component_ModalFormlMateri, {
      "show-form-materi": _ctx.setupFormMateri.show,
      "onUpdate:show-form-materi": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.setupFormMateri.show) = $event)),
      "materi-id": _ctx.setupFormMateri.id,
      "onUpdate:materi-id": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.setupFormMateri.id) = $event)),
      "materi-slug": _ctx.setupFormMateri.slug,
      "onUpdate:materi-slug": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.setupFormMateri.slug) = $event)),
      refetch: _ctx.refetchListMateri,
      "onUpdate:refetch": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.refetchListMateri) = $event))
    }, null, 8, ["show-form-materi", "materi-id", "materi-slug", "refetch"]),
    _createVNode(_component_ModalDetailMateri, {
      "show-detail-materi": _ctx.detailMateri.show,
      "onUpdate:show-detail-materi": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detailMateri.show) = $event)),
      "materi-id": _ctx.detailMateri.id,
      "onUpdate:materi-id": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.detailMateri.id) = $event))
    }, null, 8, ["show-detail-materi", "materi-id"])
  ]))
}